import React from 'react';
import If from '../utils/If';
import IconPaid from '../icon/IconPaid';
import cn from 'classnames';

type Props = {
  activeIndex: number;
};

export default function Menu({activeIndex}: Props) {
  return (
    <div className={"flex flex-row text-gray-dark mt-2"}>
      <Link linkIndex={1} currentIndex={activeIndex}>
        License type
      </Link>
      <Link linkIndex={2} currentIndex={activeIndex}>
        Renewal Notifications
      </Link>
      <Link linkIndex={3} currentIndex={activeIndex}>
        License Agreement
      </Link>
      <Link linkIndex={4} currentIndex={activeIndex}>
        Renewal Period
      </Link>
    </div>
  )
}

function CompletedStep() {
  return (
    <span
      className="inline-block rounded-full border border-blue bg-blue w-7 h-7 mr-2 text-center"><IconPaid
      className="text-white"/></span>
  )
}

function ActiveStep({value}: { value: number }) {
  return (
    <span className="inline-block rounded-full border border-blue text-blue w-7 h-7 mr-2 text-center">{value}</span>
  )
}

function Link({
                linkIndex,
                currentIndex,
                children
              }: React.PropsWithChildren<{ linkIndex: number, currentIndex: number }>) {
  const active = linkIndex === currentIndex;
  return (
    <div
      className={cn({'border-blue': active},
        {'border-gray': !active},
        {'text-blue': linkIndex <= currentIndex},
        `border-b ${linkIndex === 1 ? 'pr-4' : 'px-4'} pb-2`)}>
      <If condition={active}>
        <ActiveStep value={linkIndex}/>
      </If>
      <If condition={linkIndex < currentIndex}>
        <CompletedStep/>
      </If>
      {children}
    </div>
  )
}
